import React from 'react';

import { IconButton } from '@mui/material';

import { ArrowNew } from '~/assets/images';

const OlcBulkSelectionDropdown = ({
  ariaLabel,
  menuId = 'account-menu',
  onClick,
  open = false,
}) => (
  <IconButton
    aria-label={ariaLabel}
    onClick={onClick}
    size="small"
    aria-controls={open ? menuId : undefined}
    aria-haspopup="true"
    aria-expanded={open ? 'true' : undefined}
    disableRipple
    className="bulkActionsDropIcon"
  >
    <ArrowNew
      fill="#000"
      style={{
        transform: open ? 'rotate(180deg)' : undefined,
        width: '24px',
      }}
    />
  </IconButton>
);

export default OlcBulkSelectionDropdown;
